import { CM, TEXT_KEEP_ALL_SX } from './home-theme';
import { HOME_STICKY_CTA_ROOM } from '../components/home-sticky-cta';

// ----------------------------------------------------------------------

/** 랜딩 바탕 — 흰 바탕 · 폰은 아래 고정 단추 자리만큼 띄운다 · 낱말 단위 줄바꿈을 글자·단추에 전파 */
export const HOME_PAGE_SX = {
  bgcolor: '#fff',
  color: CM.text,
  width: '100%',
  overflow: 'hidden',
  pb: { xs: `${HOME_STICKY_CTA_ROOM}px`, sm: 0 },
  ...TEXT_KEEP_ALL_SX,
  '& .MuiTypography-root, & .MuiButton-root, & button': TEXT_KEEP_ALL_SX,
};

/** 맨 위로 단추 — 폰에서는 아래 고정 단추 위로 올린다(겹치면 둘 다 엄지에 걸린다) */
export const HOME_BACK_TO_TOP_SX = { bottom: { xs: HOME_STICKY_CTA_ROOM + 16, sm: 24, md: 32 } };
